// frontend/src/App.js
import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AuthContext from './context/AuthContext';
import { setupAuthToken } from './services/api';
import Navbar from './components/Navbar';
import NavbarClinica from './components/NavbarClinica';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';
import CadastroPage from './pages/CadastroPage';
import CalendarioPage from './pages/CalendarioPage';
import CalendarioPacientePage from './pages/CalendarioPacientePage';
import DocumentosPage from './pages/DocumentosPage.jsx';
import AvaliacaoPage from './pages/AvaliacaoPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import RegisterClinicaPage from './pages/RegisterClinicaPage';
import MeuPainelPage from './pages/MeuPainelPage';
import AdminPage from './pages/AdminPage';
import AguardandoAprovacaoPage from './pages/AguardandoAprovacaoPage';
import VerificarEmailPage from './pages/VerificarEmailPage';
import EsqueciSenhaPage from './pages/EsqueciSenhaPage';
import ResetarSenhaPage from './pages/ResetarSenhaPage';
import NaoAutorizadoPage from './pages/NaoAutorizadoPage';
import PerfilPage from './pages/PerfilPage';
import FinanceiroPage from './pages/FinanceiroPage';
import ClinicaDashboardPage from './pages/ClinicaDashboardPage';
import ClinicaPacientesPage from './pages/ClinicaPacientesPage';
import ClinicaPilatesPage from './pages/ClinicaPilatesPage';
import ClinicaFinanceiroPage from './pages/ClinicaFinanceiroPage';
import ClinicaPerfilPage from './pages/ClinicaPerfilPage';

setupAuthToken();

const App = () => {
  const { isAuthenticated, loading, isClinica } = useContext(AuthContext);

  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 5000,
            style: { background: '#363636', color: '#fff' },
            success: { duration: 3000, theme: { primary: 'green', secondary: 'black' } },
          }}
        />
        {/* CRITICAL: !loading before rendering navbar */}
        {isAuthenticated && !loading && !isClinica && <Navbar />}
        {isAuthenticated && !loading && isClinica && <NavbarClinica />}
        <main>
          <Routes>
            {/* Público */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register/clinica" element={<RegisterClinicaPage />} />
            <Route path="/aguardando-aprovacao" element={<AguardandoAprovacaoPage />} />
            <Route path="/verificar-email/:token" element={<VerificarEmailPage />} />
            <Route path="/esqueci-senha" element={<EsqueciSenhaPage />} />
            <Route path="/resetar-senha/:token" element={<ResetarSenhaPage />} />
            <Route path="/nao-autorizado" element={<NaoAutorizadoPage />} />

            {/* Fisioterapeuta + Admin */}
            <Route element={<ProtectedRoute roles={['fisioterapeuta', 'admin']} />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/avaliacao" element={<AvaliacaoPage />} />
              <Route path="/cadastro" element={<CadastroPage />} />
              <Route path="/calendario" element={<CalendarioPage />} />
              <Route path="/documentos" element={<DocumentosPage />} />
              <Route path="/perfil" element={<PerfilPage />} />
              <Route path="/financeiro" element={<FinanceiroPage />} />
            </Route>

            {/* Admin */}
            <Route element={<ProtectedRoute roles={['admin']} />}>
              <Route path="/admin" element={<AdminPage />} />
            </Route>

            {/* Paciente */}
            <Route element={<ProtectedRoute roles={['paciente']} />}>
              <Route path="/meu-painel" element={<MeuPainelPage />} />
              <Route path="/meu-calendario" element={<CalendarioPacientePage />} />
            </Route>

            {/* Clínica — SEPARADO, fora do bloco fisioterapeuta */}
            <Route element={<ProtectedRoute roles={['clinica']} />}>
              <Route path="/clinica/dashboard" element={<ClinicaDashboardPage />} />
              <Route path="/clinica/pacientes" element={<ClinicaPacientesPage />} />
              <Route path="/clinica/pilates" element={<ClinicaPilatesPage />} />
              <Route path="/clinica/financeiro" element={<ClinicaFinanceiroPage />} />
              <Route path="/clinica/perfil" element={<ClinicaPerfilPage />} />
            </Route>
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;